import React, { useState } from 'react';

// Удаление аккаунта изнутри приложения (требование Google Play и App Store).
export default function DeleteAccount({ onDelete }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const click = async () => {
    if (!window.confirm('Удалить аккаунт и все данные безвозвратно?\nВидалити акаунт і всі дані безповоротно?')) return;
    setBusy(true); setError('');
    try {
      await onDelete();
    } catch (e) {
      setError(e.response?.data?.detail || 'Не удалось удалить аккаунт. Попробуйте позже.');
      setBusy(false);
    }
  };

  return (
    <div style={{ textAlign: 'center', marginTop: 28 }}>
      <button onClick={click} disabled={busy}
        style={{ background: 'none', border: 'none', color: '#8888aa', fontSize: 13, textDecoration: 'underline', cursor: 'pointer' }}>
        {busy ? 'Удаляем…' : 'Удалить аккаунт / Видалити акаунт'}
      </button>
      {error && <p style={{ color: '#e74c3c', fontSize: 13, marginTop: 8 }}>{error}</p>}
    </div>
  );
}
